import { getSolutionIdFromName, isSolutionValid } from "./utils/helperFunctions";
/**
 * List of supported device model ids
 * @constant
 * @default default ['6144007', '540938247', '72780372515670', '72986808818502']
 */
export var deviceModelIds = ['6144007', '540938247', '72780372515670', '72986808818502'];
/**
 * Gets the fine tuning file for a specific device model id
 *
 * @param deviceModelId Input model id for the hearing device
 * @returns Returns the fine tuning file for the device
 */
export function getFineTuningFile(deviceModelId) {
    if (!deviceModelIds.includes(deviceModelId)) {
        console.error("\nError: The Finetuning file for device ".concat(deviceModelId, " is not available."));
        return null;
    }
    try {
        return require("./OTC_Tool_FineTuningPreprocessor_Output/".concat(deviceModelId, "_FineTuning_Config.json"));
    }
    catch (error) {
        console.error("Module not found: ".concat(error.message));
        return null;
    }
}
/**
 * Gets the fine tuning categories for a specific device model id
 *
 * @param deviceModelId Input model id for the hearing device
 * @returns Returns the fine tuning categories
 */
export function getCategories(deviceModelId) {
    var _a;
    var fineTuningConfigData = getFineTuningFile(deviceModelId);
    var inputCategoryList = (_a = fineTuningConfigData === null || fineTuningConfigData === void 0 ? void 0 : fineTuningConfigData.Category) !== null && _a !== void 0 ? _a : [];
    var outputCategoryList = [];
    for (var _i = 0, inputCategoryList_1 = inputCategoryList; _i < inputCategoryList_1.length; _i++) {
        var category = inputCategoryList_1[_i];
        outputCategoryList.push({ Id: category.Id, Name: category.Name });
    }
    return outputCategoryList;
}
/**
 * Gets the fine tuning problems for a specific device model id
 *
 * @param deviceModelId Input model id for the hearing device
 * @returns Returns the fine tuning problems
 */
export function getProblems(deviceModelId, categoryId) {
    var _a;
    var fineTuningConfigData = getFineTuningFile(deviceModelId);
    var categories = (_a = fineTuningConfigData === null || fineTuningConfigData === void 0 ? void 0 : fineTuningConfigData.Category) !== null && _a !== void 0 ? _a : [];
    var selectedCategory = categories.find(function (category) { return category.Id == categoryId; });
    var outputProblemList = [];
    var inputProblemList = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.Attribute;
    if (inputProblemList) {
        for (var _i = 0, inputProblemList_1 = inputProblemList; _i < inputProblemList_1.length; _i++) {
            var problem = inputProblemList_1[_i];
            outputProblemList.push({ Id: problem.Id, Name: problem.Name });
        }
    }
    return outputProblemList;
}
/**
 * Gets the fine tuning solutions for a specific device model id
 *
 * @param deviceModelId Input model id for the hearing device
 * @returns Returns the fine tuning solutions
 */
export function getSolutions(deviceModelId, categoryId, problemId, currentMasterGain, currentFourBandEqualizer, minMasterGain, maxMasterGain) {
    var _a;
    var fineTuningConfigData = getFineTuningFile(deviceModelId);
    var categories = (_a = fineTuningConfigData === null || fineTuningConfigData === void 0 ? void 0 : fineTuningConfigData.Category) !== null && _a !== void 0 ? _a : [];
    var selectedCategory = categories.find(function (category) { return category.Id == categoryId; });
    var problems = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.Attribute;
    var selectedProblem = problems === null || problems === void 0 ? void 0 : problems.find(function (problem) { return problem.Id == problemId; });
    var inputSolutionList = selectedProblem === null || selectedProblem === void 0 ? void 0 : selectedProblem.Solution;
    var outputSolutionList = [];
    if (inputSolutionList) {
        for (var _i = 0, inputSolutionList_1 = inputSolutionList; _i < inputSolutionList_1.length; _i++) {
            var solution = inputSolutionList_1[_i];
            if (fineTuningConfigData) {
                var solutionId = getSolutionIdFromName(fineTuningConfigData, solution);
                if (solutionId) {
                    var offset = getSolution(deviceModelId, solutionId);
                    if (offset &&
                        isSolutionValid(offset, currentMasterGain, currentFourBandEqualizer, minMasterGain, maxMasterGain)) {
                        outputSolutionList.push({ Id: solutionId, Name: solution });
                    }
                }
            }
        }
    }
    return outputSolutionList;
}
/**
 * Gets the fine tuning solution for a specific device model id and solution id
 *
 * @param deviceModelId Input model id for the hearing device
 * @param solutionId Input solution id
 * @returns Returns the fine tuning solution for a specific device model id and solution id
 */
export function getSolution(deviceModelId, solutionId) {
    var _a;
    var fineTuningConfigData = getFineTuningFile(deviceModelId);
    var solutions = (_a = fineTuningConfigData === null || fineTuningConfigData === void 0 ? void 0 : fineTuningConfigData.Solution) !== null && _a !== void 0 ? _a : [];
    var selectedSolution = solutions.find(function (solution) { return solution.Id == solutionId; });
    return selectedSolution === null || selectedSolution === void 0 ? void 0 : selectedSolution.Offset;
}
export default {
    getCategories: getCategories,
    getFineTuningFile: getFineTuningFile,
    getProblems: getProblems,
    getSolutions: getSolutions,
    getSolution: getSolution
};
